import { getContract, toTokens } from 'thirdweb'
import { allowance } from 'thirdweb/extensions/erc20'
import { useReadContract } from 'thirdweb/react'

import Client from '../client'
import {
  CHAIN_IDS_TO_TOKEN_MESSENGER_ADDRESSES,
  CHAIN_IDS_TO_USDC_ADDRESSES,
} from '../constants/address'
import { CHAIN_IDS_TO_CHAINS } from '../constants/chain'
import { DEFAULT_DECIMALS } from '../constants/token'

import type { SupportedChainId } from '../constants/chain'

/**
 * Returns the allowance amount (e.g. 1 = 1 USDC) of the USDC contract
 * on the given chain from the ownerAddress,
 * to be spent by the Token Messenger contract.
 * @param chainId - The chain ID that given USDC contract address is on.
 * @param ownerAddress - The wallet owner's address.
 */
export const useUsdcAllowance = (
  chainId: SupportedChainId,
  ownerAddress: string,
) => {
  const client = Client.instance
  const chain = CHAIN_IDS_TO_CHAINS[chainId]
  const contractAddress = CHAIN_IDS_TO_USDC_ADDRESSES[chainId]
  const spenderAddress = CHAIN_IDS_TO_TOKEN_MESSENGER_ADDRESSES[chainId]

  const contract = getContract({
    client,
    address: contractAddress,
    chain,
  })

  const {
    data: rawData,
    isLoading,
    error,
  } = useReadContract(allowance, {
    contract,
    owner: ownerAddress,
    spender: spenderAddress,
  })

  return {
    data: toTokens(rawData ?? BigInt(0), DEFAULT_DECIMALS),
    isLoading,
    error,
  }
}
